import { prefix } from 'inline-style-prefixer';

// @ts-ignore

export default prefix;
